import { useEffect, useRef } from 'react'
import { useToast } from '@komi-app/creator-ui'

import { useMaintenance, MAINTENANCE_TOAST_TEXT } from 'hooks/maintenance'

/**
 * Renders nothing: raises the persistent maintenance toast once when
 * CONSUMER_TRAFFIC_ONLY turns on. Must be mounted inside `ToastContextProvider`.
 */
export const MaintenanceToast = () => {
  const maintenance = useMaintenance()
  const { createToast } = useToast()
  const raised = useRef(false)

  useEffect(() => {
    if (!maintenance || raised.current) return

    raised.current = true

    createToast({
      semantic: 'error',
      text: MAINTENANCE_TOAST_TEXT,
      dismissible: false
    })
  }, [maintenance, createToast])

  return null
}

export default MaintenanceToast
